const config = {
  proxy: "https://cors-anywhere.ardittristan.workers.dev/corsproxy/?apiurl=",
};

export default config;
